










































import { Component, mixins } from '@niknevis/vue-modules'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import QTable from 'quasar/src/components/table/QTable.js';
import Pagination from '@/modules/shared/components/shared/pagination/Pagination.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import NewTicketButton from '@/modules/ticket/components/shared/NewTicketButton.vue'
import { TicketCollectionType } from '@/modules/ticket/models/ticket-collection.model'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { getTicketTableColumns } from '@/modules/ticket/models/columns/ticket-table.column'
import TicketTableRow from '@/modules/ticket/components/shared/table/TicketTableRow.vue'
import { PanelTicketRoute } from '@/modules/ticket/routes/panel-ticket.route'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'لیست تیکت‌ها',
    page_sub_header: 'شما میتوانید لیست تیکت های خود را در اینجا مشاهده کنید و همچنین تیکت جدید ایجاد کنید'
  },
  metaInfo: {
    title: 'لیست تیکت ها'
  },
  components: {
    NewTicketButton,
    BaseButton,
    FilterRow,
    Heading,
    Pagination,
    TesTable
  }
})
export default class PanelTicketIndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  constructor(
    private readonly panelRoutes: PanelTicketRoute
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() tickets!: TicketCollectionType

  @ProvideReactive()
  get routes() {
    return this.panelRoutes
  }

  private rowComponent = TicketTableRow

  private filters = [
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت',
      key: 'statuses',
      holder: 'همه وضعیت ها',
      typeMode: false,
      items: collect(this.tickets.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ ثبت',
      keys: {
        to: 'created_at_to',
        from: 'created_at_from'
      },
      holder: 'انتخاب کنید',
      typeMode: false,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ]
    })
  ]

  protected get model() {
    return this.tickets
  }

  updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  private ticketColumn: QTable['columns'] = getTicketTableColumns()
}
